module.exports = __webpack_public_path__ + "static/media/AI_infantry.cf7f8340.png";